import React, { useMemo } from "react";
import { StyleSheet } from "react-native";
import { DataTable, Surface, Text } from "react-native-paper";
import { PaymentDataItem } from "./types";

interface PaymentsTableProps {
  data: PaymentDataItem[];
  weekDates: Date[];
}

export const PaymentsTable: React.FC<PaymentsTableProps> = ({
  data,
  weekDates,
}) => {
  const formatDate = (date: Date) => {
    return date.toLocaleDateString("ru-RU");
  };

  // Пересчитываем итоги для текущей недели
  const weekTotals = useMemo(() => {
    return data.reduce(
      (acc, item) => {
        acc.cash += item.cash;
        acc.kaspi += item.kaspi;
        acc.halyk += item.halyk;
        return acc;
      },
      { cash: 0, kaspi: 0, halyk: 0 },
    );
  }, [data]);

  return (
    <Surface style={styles.container} elevation={1}>
      <Text variant="titleMedium" style={styles.tableTitle}>
        Оплаты
      </Text>
      <DataTable>
        <DataTable.Header>
          <DataTable.Title style={{ flex: 0.4 }}>Дата</DataTable.Title>
          <DataTable.Title numeric>Наличные</DataTable.Title>
          <DataTable.Title numeric>Kaspi</DataTable.Title>
          <DataTable.Title numeric>Halyk</DataTable.Title>
          <DataTable.Title numeric>Итого</DataTable.Title>
        </DataTable.Header>

        {weekDates.map((date) => {
          const dateStr = formatDate(date);
          const dayPayments = data.filter((item) => item.date === dateStr);
          const dayData = dayPayments.reduce(
            (sums, day) => {
              sums.cash += day.cash;
              sums.kaspi += day.kaspi;
              sums.halyk += day.halyk;
              return sums;
            },
            {
              cash: 0,
              kaspi: 0,
              halyk: 0,
            },
          );
          const dayTotal = dayData.cash + dayData.kaspi + dayData.halyk;

          return (
            <DataTable.Row key={dateStr}>
              <DataTable.Cell style={{ flex: 0.4 }}>{dateStr}</DataTable.Cell>
              <DataTable.Cell numeric>
                {dayData.cash > 0 ? dayData.cash.toLocaleString("ru-RU") : "-"}
              </DataTable.Cell>
              <DataTable.Cell numeric>
                {dayData.kaspi > 0
                  ? dayData.kaspi.toLocaleString("ru-RU")
                  : "-"}
              </DataTable.Cell>
              <DataTable.Cell numeric>
                {dayData.halyk > 0
                  ? dayData.halyk.toLocaleString("ru-RU")
                  : "-"}
              </DataTable.Cell>
              <DataTable.Cell numeric>
                {dayTotal > 0 ? dayTotal.toLocaleString("ru-RU") : "-"}
              </DataTable.Cell>
            </DataTable.Row>
          );
        })}

        <DataTable.Row>
          <DataTable.Cell style={{ flex: 0.4 }}>Итог</DataTable.Cell>
          <DataTable.Cell numeric>
            {weekTotals.cash > 0
              ? weekTotals.cash.toLocaleString("ru-RU")
              : "-"}
          </DataTable.Cell>
          <DataTable.Cell numeric>
            {weekTotals.kaspi > 0
              ? weekTotals.kaspi.toLocaleString("ru-RU")
              : "-"}
          </DataTable.Cell>
          <DataTable.Cell numeric>
            {weekTotals.halyk > 0
              ? weekTotals.halyk.toLocaleString("ru-RU")
              : "-"}
          </DataTable.Cell>
          <DataTable.Cell numeric>
            {(
              weekTotals.cash +
              weekTotals.kaspi +
              weekTotals.halyk
            ).toLocaleString("ru-RU")}
          </DataTable.Cell>
        </DataTable.Row>
      </DataTable>
    </Surface>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 24,
    borderRadius: 8,
  },
  tableTitle: {
    padding: 16,
    paddingBottom: 8,
  },
});
